module.exports = __webpack_public_path__ + "img/done-checking.c27d66a3.svg";